import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { BsClipboardPlus } from 'react-icons/bs';

interface CopyButtonProps {
  textToCopy: string;
  size?: 'sm' | 'lg';
  tooltipText?: string;
}

export const CopyButton = ({
  textToCopy,
  size = 'sm',
  tooltipText = 'Copy to Clipboard',
}: CopyButtonProps) => {
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(textToCopy);
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  };

  return (
    <OverlayTrigger placement="top" overlay={<Tooltip>{tooltipText}</Tooltip>}>
      <Button size={size} variant="link" onClick={handleCopy}>
        <BsClipboardPlus className="mb-2" />
      </Button>
    </OverlayTrigger>
  );
};
